// extracted by mini-css-extract-plugin
export var brand = "Scaffold-module--brand--042a4";
export var content = "Scaffold-module--content--93539";
export var footer = "Scaffold-module--footer--26c3d";
export var header = "Scaffold-module--header--fa80a";
export var light = "Scaffold-module--light--b443e";
export var scaffold = "Scaffold-module--scaffold--0056b";